class Utils {
    static formatDate = (date) => {
        if (!date) return '';
        return date.replaceAll('-', '.');
    };
}

export default Utils;
